<template>
  <div :title="item.title">
    <!--    <svg-icon :name="item.status==='true'?'green':'red'"/>-->
    <img v-if="item.status==='true'||item.camStatus==='1'" src="@/assets/green.png">
    <img v-else src="@/assets/red.png">
  </div>
</template>

<script>
  export default {
    name: "DeviceStatusItem2",
    props: ['item']
  }
</script>

<style scoped lang="less">
  .deviceStatusdiv {
    img {
      height: 42px;
      width: 42px;
    }
  }
</style>
